import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const GET_WHD_FORMS_REQUEST = 'GET_WHD_FORMS_REQUEST';
export const GET_WHD_FORMS_SUCCESS = 'GET_WHD_FORMS_SUCCESS';
export const GET_WHD_FORMS_FAILURE = 'GET_WHD_FORMS_FAILURE';

function requestGetWhdForms() {
  return {
    type: GET_WHD_FORMS_REQUEST,
    isGettingWhdForms: true
  };
}

function receiveGetWhdForms(whdForms) {
  return {
    type: GET_WHD_FORMS_SUCCESS,
    isGettingWhdForms: false,
    whdForms
  };
}

function rejectGetWhdForms() {
  return {
    type: GET_WHD_FORMS_FAILURE,
    isGettingWhdForms: false
  };
}

export function getWhdForms(accountNo) {
  return (dispatch) => {
    dispatch(requestGetWhdForms());
    const promise = () => ApiService
      .getWhdPaymentCalculations(accountNo)
      .then((response) => {
        dispatch(receiveGetWhdForms(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectGetWhdForms, true));
        }
      });
    return promise();
  };
}
